class CommonStatus {
  public static get INACTIVED() {
    return 0;
  }

  public static get ACTIVED() {
    return 1;
  }

  public static get LOCKED() {
    return 2;
  }
}

CommonStatus[CommonStatus.ACTIVED] = {
  label: 'Đang hoạt động',
  color: 'var(--microui-color-success-400)',
};
CommonStatus[CommonStatus.LOCKED] = {
  label: 'Đã khóa',
  color: 'var(--microui-color-warning-400)',
};

CommonStatus[CommonStatus.INACTIVED] = {
  label: 'Đã xóa',
  color: 'var(--microui-color-error-400)',
};

export default CommonStatus;
